var moment = require('moment')

const priceFormatter = new Intl.NumberFormat(global.dataInit.culture, {
  style: 'currency',
  minimumFractionDigits: 2,
  currency: 'EUR'
})

export default class {
  constructor (payment) {
    this.done = payment.done
    this.date = moment(payment.date, 'YYYYMMDDHHmmss')
    this.amount = payment.amount
    this.iban = payment.iban
  }

  get formatedDate () {
    return this.date.format('L')
  }

  get formatedAmount () {
    if (this.amount && this.amount !== null) {
      return priceFormatter.format(this.amount)
    } else {
      return ''
    }
  }
}
